import { useEffect } from 'react'
import { callsWs } from '../ws/callsClient'
import { useCallStore } from '../stores/callStore'

export function useCallsSocket(token: string | null) {
  useEffect(() => {
    if (!token) return

    callsWs.connect(token)

    const off = callsWs.on((sig) => {
      if (sig.type === 'call.invite') {
        const payload = sig.payload as { call_type?: string; caller_id?: string } | undefined
        useCallStore.getState().setIncoming({
          roomId: sig.room_id ?? '',
          callerId: sig.from ?? payload?.caller_id ?? '',
          callType: (payload?.call_type ?? 'voice') as 'voice' | 'video',
        })
      }

      if (sig.type === 'call.end' || sig.type === 'call.busy') {
        // Clear incoming if the call was cancelled before we answered
        const current = useCallStore.getState().incoming
        if (current && current.roomId === sig.room_id) {
          useCallStore.getState().setIncoming(null)
        }
      }
    })

    return () => {
      off()
      callsWs.disconnect()
    }
  }, [token])
}
